/* eslint-disable react-hooks/exhaustive-deps */
import './organizerTrips.css';
import { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import ReactLoading from 'react-loading';
import { getOrganizerTrips } from '../../fetchData';
import TripCard from '../../components/tripCard/TripCard';
import EmptyPage from '../../../components/empty-page/emptyPage';
import { useOrganizer } from '../../context/OrganizerContext';

const OrganizerTrips = () => {
    const [data, setData] = useState([]);
    const [type, setType] = useState('trip');
    const [loading, setLoading] = useState(false);
    const [limit] = useState(3);
    const [offset, setOffset] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const loaderRef = useRef(null);
    const { id } = useParams();
    const { searchValue } = useOrganizer();

    useEffect(() => {
        setType((prev) => prev);
    }, []);

    // useEffect(() => {
    //     if (!id) return;
    //     getOrganizerInfo(type, id, setOrganizer, setLoading);
    // }, [id]);

    useEffect(() => {
        if (!id) return;
        getOrganizerTrips(type, id, limit, offset, setHasMore, setData, setLoading);
    }, [offset]);

    // useEffect(() => {
    //     if (!loaderRef.current || !hasMore) return;

    //     const observer = new IntersectionObserver((entries) => {
    //         if (entries[0].isIntersecting) {
    //             setOffset((prev) => prev + limit);
    //         }
    //     });

    //     observer.observe(loaderRef.current);

    //     return () => {
    //         if (loaderRef.current) observer.unobserve(loaderRef.current);
    //     };
    // }, [loaderRef, hasMore]);

    useEffect(() => {
        const titleBar = document.querySelector('.customTitle');
        if (!titleBar) return;

        let ticking = false;

        const handleScroll = () => {
            const scrollY = window.scrollY;
            const shouldBeScrolled = scrollY >= 70;

            if (shouldBeScrolled) {
                titleBar.classList.add('scrolled');
            } else {
                titleBar.classList.remove('scrolled');
            }

            ticking = false;
        };

        const onScroll = () => {
            if (!ticking) {
                window.requestAnimationFrame(handleScroll);
                ticking = true;
            }
        };

        window.addEventListener('scroll', onScroll);
        handleScroll();

        return () => {
            window.removeEventListener('scroll', onScroll);
        };
    }, []);

    const filterData = data.filter((item) => item?.title?.toLowerCase().includes(searchValue.toLowerCase()));
    return (
        <>
            {/* <TitleBar image={organizer?.logo} title={organizer?.companyName} className='customTitle aboutSticky' /> */}
            {/* {id && (
                <CustomHeader
                    leftItems={['logo']}
                    logo={organizer?.logo}
                    companyName={organizer?.companyName}
                    centerItems={['search']}
                    rightItems={['login', 'signup', 'menuIcons']}
                    onSearch={setDebounceSearch}
                    searchValue={debounceSearch}
                    setDebounceSearch={setDebounceSearch}
                />
            )} */}
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            <div className='custom-container'>
                <div className='blogsGrid_org'>
                    <TripCard imageData={filterData} />
                </div>
                {/* <div className='powered-by-logo'>
                    <h1>Powered By</h1>
                    <Link to='/'>
                        <img alt='trvto logo' src={logo} className='headerLogoImg' />
                    </Link>
                </div> */}
                {filterData?.length === 0 && <EmptyPage />}
                <div ref={loaderRef} style={{ height: '40px' }}></div>
            </div>
        </>
    );
};

export default OrganizerTrips;
